import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAccessories } from '../store/actions/accessories';
import { getAddons } from '../store/actions/addons';
import Configurator from '../components/configurator/Configurator';
import AccessoriesConfig from '../components/configurationOptions/AccessoriesConfig';
import ProgressBar from '../components/ProgressBar';
import { WardrobesConfigsContext } from '../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../contexts/ActiveWardrobeContext';
import ReactGA from 'react-ga';

const AccessoriesConfiguration = props => {
  useEffect(() => {
    ReactGA.event(
      {
        category: 'Accessories',
        action: 'Accessories configuration',
        transport: 'beacon',
      },
      ['tracker1', 'tracker2'],
    );
  }, []);

  const { accessories, getAccessories, addonsList, getAddons, dedicatedAccessories } = props;
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const wardrobe = wardrobesConfigs[activeWardrobe];
  const [addonsLoad, setAddonsLoad] = useState(false);
  const [accessoriesLoad, setAccessoriesLoad] = useState(false);

  const getData = React.useCallback(() => {
    if (!accessoriesLoad) {
      setAccessoriesLoad(true);
      getAccessories(wardrobe.safo, wardrobe.dimensions.x, wardrobe.dimensions.z);
    }

    if (!wardrobe.withoutDoor) {
      if (addonsList.length === 0 && !addonsLoad) {
        setAddonsLoad(true);
        getAddons(wardrobe.dimensions.x);
      } else {
        wardrobe.addons.fronts = addonsList.filter(
          item => item.safo.includes('FRN') && item.dimensions.y === wardrobe.dimensions.y,
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    wardrobe.safo,
    accessories.length,
    addonsList,
    getAccessories,
    getAddons,
    wardrobe.addons.fronts,
    wardrobe.dimensions.x,
    wardrobe.dimensions.y,
    wardrobe.dimensions.z,
  ]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Configurator>
      <ProgressBar link="/accessories-start" activeLvl={2} />
      <AccessoriesConfig
        addonsList={addonsList}
        accessories={accessories}
        dedicatedAccessories={dedicatedAccessories}
      />
    </Configurator>
  );
};

const mapStateToProps = state => {
  return {
    accessories: state.accessories.accessories,
    addonsList: state.addons.addons,
    dedicatedAccessories: state.accessories.dedicatedAccessories,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAccessories: (safo, width, depth) => dispatch(getAccessories(safo, width, depth)),
    getAddons: width => dispatch(getAddons(width)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessoriesConfiguration);
